.features-card-type-4 {
  border-top-left-radius: var(--radius-size-lg);
  border-top-right-radius: var(--radius-size-lg);
}

.features-card-type-4--variant-default {
  background-color: var(--background-color-brand-primary-lightest);

  .me-button--ghost {
    color: var(--text-color-brand-primary);

    &:hover {
      color: var(--text-color-brand-primary);
    }

    &::before {
      background-color: var(--text-color-brand-primary);
    }
  }
}

.features-card-type-4--variant-dark {
  color: var(--text-color-alternate);
  background-color: #100419;

  .me-button--ghost {
    color: var(--text-color-alternate);

    &:hover {
      color: var(--text-color-alternate);
    }

    &::before {
      background-color: var(--text-color-alternate);
    }
  }
}

.features-card__info {
  padding: var(--spacing-xl);

  @include desktop {
    padding: var(--spacing-4xl);
  }

  .me-text {
    min-height: 72px;
  }
}
